import { __rest } from 'tslib';
import React from 'react';
import { styled } from '@teko/ui';

const Wrapper = styled.div((props) => `
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: ${props.selected ? '#f5f5f5' : '#fff'};
    padding: 0.6rem;
    cursor: ${props.onClick ? 'pointer' : ''};
    &:hover {
      background-color: ${props.type !== 'search-suggestion' && '#f5f5f5'};
    }
  `);
const Title = styled.div `
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: ${(props) => props.numberOfLine};
  overflow: hidden;
  margin: 0 0.6rem;
  flex: 1;
`;
const ListTile = React.forwardRef((_a, ref) => {
    var { leading, title, trailing, numberOfLine = 1, onClick, onMouseEnter, type, selected = false } = _a, props = __rest(_a, ["leading", "title", "trailing", "numberOfLine", "onClick", "onMouseEnter", "type", "selected"]);
    return (React.createElement(Wrapper, Object.assign({ ref: ref, selected: selected, onMouseEnter: onMouseEnter }, props, { onClick: onClick, type: type }),
        leading,
        React.createElement(Title, { numberOfLine: numberOfLine }, title),
        trailing));
});
ListTile.displayName = 'ListTile';

export { ListTile };
